// # Map of country names to ISO codes for heat map visualization
// # This file provides ISO 3166-1 alpha-3 codes for countries in nationality_data.js

/**
 * # Country ISO Codes Map
 * Maps country names to their ISO 3166-1 alpha-3 codes
 * Used for mapping country data in heat maps and geographic visualizations
 * @type {Object}
 */
export const countryISOMap = {
  // # Arab Countries
  "Egypt": "EGY",
  "EGYPT": "EGY",
  "Algeria": "DZA",
  "ALGERIA": "DZA",
  "Bahrain": "BHR",
  "Comoros": "COM",
  "COMOROS": "COM",
  "Djibouti": "DJI",
  "Iraq": "IRQ",
  "Jordan": "JOR",
  "Kuwait": "KWT",
  "Lebanon": "LBN",
  "Libya": "LBY",
  "Mauritania": "MRT",
  "Morocco": "MAR",
  "Oman": "OMN",
  "OMAN": "OMN",
  "Palestine": "PSE",
  "Qatar": "QAT",
  "Saudi Arabia": "SAU",
  "SAUDI_ARABIA": "SAU",
  "Somalia": "SOM",
  "SOMALIA": "SOM",
  "Sudan": "SDN",
  "SUDAN": "SDN",
  "Syria": "SYR",
  "SYRIA": "SYR",
  "Tunisia": "TUN",
  "TUNISIA": "TUN",
  "United Arab Emirates": "ARE",
  "UAE": "ARE",
  "UNITED_ARAB_EMIRATES": "ARE",
  "UNITED ARAB EMIRATES": "ARE",
  "Yemen": "YEM",
  "YEMEN": "YEM",
  
  // # Asia
  "Afghanistan": "AFG",
  "AFGHANISTAN": "AFG",
  "Bangladesh": "BGD",
  "Bhutan": "BTN",
  "Brunei": "BRN",
  "BRUNEI": "BRN",
  "Cambodia": "KHM",
  "China": "CHN",
  "Hong Kong": "HKG",
  "HONG_KONG": "HKG",
  "India": "IND",
  "INDIA": "IND",
  "Indonesia": "IDN",
  "INDONESIA": "IDN",
  "Iran": "IRN",
  "Japan": "JPN",
  "JAPAN": "JPN",
  "Kazakhstan": "KAZ",
  "KAZAKHSTAN": "KAZ",
  "Kyrgyzstan": "KGZ",
  "Laos": "LAO",
  "LAOS": "LAO",
  "Macau": "MAC",
  "Malaysia": "MYS",
  "Maldives": "MDV",
  "MALDIVES": "MDV",
  "Mongolia": "MNG",
  "MONGOLIA": "MNG",
  "Myanmar": "MMR",
  "Nepal": "NPL",
  "NEPAL": "NPL",
  "North Korea": "PRK",
  "Pakistan": "PAK",
  "Philippines": "PHL",
  "PHILIPPINES": "PHL",
  "Singapore": "SGP",
  "South Korea": "KOR",
  "SOUTH_KOREA": "KOR",
  "Sri Lanka": "LKA",
  "Taiwan": "TWN",
  "Thailand": "THA",
  "THAILAND": "THA",
  "Timor-Leste": "TLS",
  "TIMOR_LESTE": "TLS",
  "Turkey": "TUR",
  "Turkmenistan": "TKM",
  "TURKMENISTAN": "TKM",
  "Uzbekistan": "UZB",
  "UZBEKISTAN": "UZB",
  "Vietnam": "VNM",
  "VIETNAM": "VNM",
  
  // # Europe
  "United Kingdom": "GBR",
  "Germany": "DEU",
  "GERMANY": "DEU",
  "France": "FRA",
  "Italy": "ITA",
  "Spain": "ESP",
  "Portugal": "PRT",
  "Netherlands": "NLD",
  "NETHERLANDS": "NLD",
  "Belgium": "BEL",
  "BELGIUM": "BEL",
  "Switzerland": "CHE",
  "Austria": "AUT",
  "AUSTRIA": "AUT",
  "Sweden": "SWE",
  "Norway": "NOR",
  "Denmark": "DNK",
  "DENMARK": "DNK",
  "Finland": "FIN",
  "FINLAND": "FIN",
  "Ireland": "IRL",
  "IRELAND": "IRL",
  "Greece": "GRC",
  "GREECE": "GRC",
  "Poland": "POL",
  "POLAND": "POL",
  "Romania": "ROU",
  "ROMANIA": "ROU",
  "Hungary": "HUN",
  "Czech Republic": "CZE",
  "CZECH_REPUBLIC": "CZE",
  "Slovakia": "SVK",
  "SLOVAKIA": "SVK",
  "Croatia": "HRV",
  "Serbia": "SRB",
  "Bulgaria": "BGR",
  "Ukraine": "UKR",
  "UKRAINE": "UKR",
  "Russia": "RUS",
  
  // # Americas
  "United States": "USA",
  "USA": "USA",
  "Canada": "CAN",
  "Brazil": "BRA",
  "Mexico": "MEX",
  "Argentina": "ARG",
  "ARGENTINA": "ARG",
  "Chile": "CHL",
  "Colombia": "COL",
  "Peru": "PER",
  "PERU": "PER",
  "Venezuela": "VEN",
  "Ecuador": "ECU",
  "ECUADOR": "ECU",
  "Bolivia": "BOL",
  "BOLIVIA": "BOL",
  "Paraguay": "PRY",
  "Uruguay": "URY",
  "Costa Rica": "CRI",
  "COSTA_RICA": "CRI",
  "Panama": "PAN",
  "PANAMA": "PAN",
  
  // # Africa (Non-Arab)
  "South Africa": "ZAF",
  "Nigeria": "NGA",
  "Kenya": "KEN",
  "Ethiopia": "ETH",
  "Ghana": "GHA",
  "GHANA": "GHA",
  "Tanzania": "TZA",
  "TANZANIA": "TZA",
  "Uganda": "UGA",
  "UGANDA": "UGA",
  "Senegal": "SEN",
  "SENEGAL": "SEN",
  "Cameroon": "CMR",
  "CAMEROON": "CMR",
  "Ivory Coast": "CIV",
  "IVORY_COAST": "CIV",
  
  // # Oceania
  "Australia": "AUS",
  "New Zealand": "NZL",
  "Fiji": "FJI",
  "FIJI": "FJI",
  "Papua New Guinea": "PNG",
  "PAPUA_NEW_GUINEA": "PNG",
  "Samoa": "WSM",
  "Solomon Islands": "SLB",
  "Vanuatu": "VUT",
  
  // # Additional countries
  "Albania": "ALB",
  "Andorra": "AND",
  "Angola": "AGO",
  "Antigua and Barbuda": "ATG",
  "Armenia": "ARM",
  "Azerbaijan": "AZE",
  "Bahamas": "BHS",
  "Barbados": "BRB",
  "Belarus": "BLR",
  "Belize": "BLZ",
  "Benin": "BEN",
  "Bosnia and Herzegovina": "BIH",
  "Botswana": "BWA",
  "Burkina Faso": "BFA",
  "Burundi": "BDI",
  "Cabo Verde": "CPV",
  "Central African Republic": "CAF",
  "Chad": "TCD",
  "Congo": "COG",
  "Congo, Democratic Republic": "COD",
  "Cuba": "CUB",
  "Cyprus": "CYP",
  "Dominica": "DMA",
  "Dominican Republic": "DOM",
  "El Salvador": "SLV",
  "Equatorial Guinea": "GNQ",
  "Eritrea": "ERI",
  "Estonia": "EST",
  "Eswatini": "SWZ",
  "Gabon": "GAB",
  "Gambia": "GMB",
  "Georgia": "GEO",
  "Grenada": "GRD",
  "Guatemala": "GTM",
  "Guinea": "GIN",
  "Guinea-Bissau": "GNB",
  "Guyana": "GUY",
  "Haiti": "HTI",
  "Honduras": "HND",
  "Iceland": "ISL",
  "Jamaica": "JAM",
  "Kiribati": "KIR",
  "Kosovo": "XKX",
  "Latvia": "LVA",
  "Lesotho": "LSO",
  "Liberia": "LBR",
  "Liechtenstein": "LIE",
  "Lithuania": "LTU",
  "Luxembourg": "LUX",
  "Madagascar": "MDG",
  "Malawi": "MWI",
  "Mali": "MLI",
  "Malta": "MLT",
  "Marshall Islands": "MHL",
  "Mauritius": "MUS",
  "Micronesia": "FSM",
  "Moldova": "MDA",
  "Monaco": "MCO",
  "Montenegro": "MNE",
  "Mozambique": "MOZ",
  "Namibia": "NAM",
  "Nauru": "NRU",
  "Nicaragua": "NIC",
  "Niger": "NER",
  "North Macedonia": "MKD",
  "Palau": "PLW",
  "Rwanda": "RWA",
  "Saint Kitts and Nevis": "KNA",
  "Saint Lucia": "LCA",
  "Saint Vincent and the Grenadines": "VCT",
  "San Marino": "SMR",
  "Sao Tome and Principe": "STP",
  "Seychelles": "SYC",
  "Sierra Leone": "SLE",
  "Slovenia": "SVN",
  "South Sudan": "SSD",
  "Suriname": "SUR",
  "Tajikistan": "TJK",
  "Togo": "TGO",
  "Tonga": "TON",
  "Trinidad and Tobago": "TTO",
  "Tuvalu": "TUV",
  "Vatican City": "VAT",
  "Zambia": "ZMB",
  "Zimbabwe": "ZWE",
};

/**
 * # Get ISO code for a country
 * @param {string} countryName - The name of the country
 * @returns {string} The ISO code or "Unknown" if not found
 */
export const getCountryISO = (countryName) => {
  if (!countryName) return "Unknown";
  
  // # Handle case sensitivity and trimming
  const normalizedName = countryName.trim();
  
  // # Direct lookup
  if (normalizedName && countryISOMap[normalizedName]) {
    return countryISOMap[normalizedName];
  }
  
  // # Try with underscores replaced by spaces
  if (normalizedName.includes('_')) {
    const nameWithSpaces = normalizedName.replace(/_/g, ' ');
    if (countryISOMap[nameWithSpaces]) {
      return countryISOMap[nameWithSpaces];
    }
  }
  
  // # Try with spaces replaced by underscores
  if (normalizedName.includes(' ')) {
    const nameWithUnderscores = normalizedName.replace(/ /g, '_');
    if (countryISOMap[nameWithUnderscores]) {
      return countryISOMap[nameWithUnderscores];
    }
  }
  
  // # Try case-insensitive lookup
  const lowerName = normalizedName.toLowerCase();
  const countries = Object.keys(countryISOMap);
  
  // # First try exact match (case-insensitive)
  let match = countries.find(country => country.toLowerCase() === lowerName);
  if (match) return countryISOMap[match];
  
  // # Try with underscores replaced by spaces (case-insensitive)
  if (lowerName.includes('_')) {
    const lowerNameWithSpaces = lowerName.replace(/_/g, ' ');
    match = countries.find(country => country.toLowerCase() === lowerNameWithSpaces);
    if (match) return countryISOMap[match];
  }
  
  // # Try with spaces replaced by underscores (case-insensitive)
  if (lowerName.includes(' ')) {
    const lowerNameWithUnderscores = lowerName.replace(/ /g, '_');
    match = countries.find(country => country.toLowerCase() === lowerNameWithUnderscores);
    if (match) return countryISOMap[match];
  }
  
  // # Try partial match if no exact match found
  match = countries.find(country => 
    lowerName.includes(country.toLowerCase()) || 
    country.toLowerCase().includes(lowerName)
  );
  
  return match ? countryISOMap[match] : "Unknown";
};

/**
 * # Get country name from ISO code
 * @param {string} isoCode - The ISO code to look up
 * @returns {string} The country name or "Unknown" if not found
 */
export const getCountryNameFromISO = (isoCode) => {
  // # Handle case sensitivity and trimming
  const normalizedCode = isoCode?.trim()?.toUpperCase();
  
  if (!normalizedCode) return "Unknown";
  
  // # Find the country name by ISO code
  // # First, look for a nicely formatted name (first letter capitalized, rest lowercase)
  const entries = Object.entries(countryISOMap).filter(([_, code]) => code === normalizedCode);
  
  if (entries.length === 0) return "Unknown";
  
  // # Prefer names with proper capitalization (first letter uppercase, rest lowercase)
  // # and without underscores
  const properlyFormattedName = entries.find(([name, _]) => {
    // Check if first letter is uppercase and the rest are lowercase
    return (
      name.charAt(0) === name.charAt(0).toUpperCase() && 
      name.slice(1) === name.slice(1).toLowerCase() &&
      !name.includes('_')
    );
  });
  
  if (properlyFormattedName) return properlyFormattedName[0];
  
  // # Next preference: names without underscores
  const nameWithoutUnderscore = entries.find(([name, _]) => !name.includes('_'));
  if (nameWithoutUnderscore) return nameWithoutUnderscore[0];
  
  // # If no properly formatted name found, return the first one
  return entries[0][0];
};

/**
 * # Check if ISO code exists
 * @param {string} isoCode - The ISO code to check
 * @returns {boolean} True if the ISO code exists in the map
 */
export const isValidISO = (isoCode) => {
  const normalizedCode = isoCode?.trim()?.toUpperCase();
  return normalizedCode ? Object.values(countryISOMap).includes(normalizedCode) : false;
};

/**
 * # Get all ISO codes
 * @returns {string[]} Array of all ISO codes
 */
export const getAllISOCodes = () => {
  return Object.values(countryISOMap);
};

/**
 * # Get all country names
 * @returns {string[]} Array of all country names
 */
export const getAllCountryNames = () => {
  return Object.keys(countryISOMap);
};

/**
 * # Transform data from country names to ISO codes
 * @param {Object} data - Object with country names as keys
 * @returns {Object} Transformed object with ISO codes as keys
 */
export const transformDataToISO = (data) => {
  if (!data || typeof data !== 'object') return {};
  
  const transformedData = {};
  
  Object.entries(data).forEach(([countryName, value]) => {
    const isoCode = getCountryISO(countryName);
    if (isoCode !== "Unknown") {
      transformedData[isoCode] = value;
    }
  });
  
  return transformedData;
};

/**
 * # Transform data from ISO codes to country names
 * @param {Object} data - Object with ISO codes as keys
 * @returns {Object} Transformed object with country names as keys
 */
export const transformDataFromISO = (data) => {
  if (!data || typeof data !== 'object') return {};
  
  const transformedData = {};
  
  Object.entries(data).forEach(([isoCode, value]) => {
    const countryName = getCountryNameFromISO(isoCode);
    if (countryName !== "Unknown") {
      transformedData[countryName] = value;
    }
  });
  
  return transformedData;
};

/**
 * # Get continent for a country
 * @param {string} countryName - The name of the country
 * @returns {string} The continent name or "Unknown" if not found
 */
export const getCountryContinent = (countryName) => {
  // # Normalize country name for lookup
  const normalizedName = countryName?.trim();
  if (!normalizedName) return "Unknown";
  
  // # Comprehensive mapping of countries to continents
  const continentMap = {
    // # North America
    "United States": "North America",
    "Canada": "North America",
    "Mexico": "North America",
    "Costa Rica": "North America",
    "Panama": "North America",
    "Guatemala": "North America",
    "Honduras": "North America",
    "El Salvador": "North America",
    "Nicaragua": "North America",
    "Belize": "North America",
    "Cuba": "North America",
    "Jamaica": "North America",
    "Haiti": "North America",
    "Dominican Republic": "North America",
    "Bahamas": "North America",
    "Barbados": "North America",
    "Trinidad and Tobago": "North America",
    "Puerto Rico": "North America",
    
    // # South America
    "Brazil": "South America",
    "Argentina": "South America",
    "Chile": "South America",
    "Colombia": "South America",
    "Peru": "South America",
    "Venezuela": "South America",
    "Ecuador": "South America",
    "Bolivia": "South America",
    "Paraguay": "South America",
    "Uruguay": "South America",
    "Guyana": "South America",
    "Suriname": "South America",
    
    // # Europe
    "United Kingdom": "Europe",
    "Germany": "Europe",
    "France": "Europe",
    "Italy": "Europe",
    "Spain": "Europe",
    "Portugal": "Europe",
    "Netherlands": "Europe",
    "Belgium": "Europe",
    "Switzerland": "Europe",
    "Austria": "Europe",
    "Sweden": "Europe",
    "Norway": "Europe",
    "Denmark": "Europe",
    "Finland": "Europe",
    "Ireland": "Europe",
    "Greece": "Europe",
    "Poland": "Europe",
    "Romania": "Europe",
    "Hungary": "Europe",
    "Czech Republic": "Europe",
    "Slovakia": "Europe",
    "Croatia": "Europe",
    "Serbia": "Europe",
    "Bulgaria": "Europe",
    "Ukraine": "Europe",
    "Russia": "Europe",
    "Belarus": "Europe",
    "Lithuania": "Europe",
    "Latvia": "Europe",
    "Estonia": "Europe",
    "Slovenia": "Europe",
    "Bosnia and Herzegovina": "Europe",
    "Albania": "Europe",
    "North Macedonia": "Europe",
    "Montenegro": "Europe",
    "Moldova": "Europe",
    "Iceland": "Europe",
    "Luxembourg": "Europe",
    "Malta": "Europe",
    "Cyprus": "Europe",
    
    // # Asia
    "China": "Asia",
    "Japan": "Asia",
    "South Korea": "Asia",
    "North Korea": "Asia",
    "India": "Asia",
    "Pakistan": "Asia",
    "Bangladesh": "Asia",
    "Indonesia": "Asia",
    "Philippines": "Asia",
    "Vietnam": "Asia",
    "Thailand": "Asia",
    "Myanmar": "Asia",
    "Malaysia": "Asia",
    "Singapore": "Asia",
    "Nepal": "Asia",
    "Sri Lanka": "Asia",
    "Cambodia": "Asia",
    "Laos": "Asia",
    "Mongolia": "Asia",
    "Taiwan": "Asia",
    "Hong Kong": "Asia",
    "Macau": "Asia",
    "Bhutan": "Asia",
    "Brunei": "Asia",
    "Timor-Leste": "Asia",
    "Maldives": "Asia",
    
    // # Middle East (geographically part of Asia but often considered separately)
    "Saudi Arabia": "Asia",
    "Iran": "Asia",
    "Iraq": "Asia",
    "Turkey": "Asia",
    "Syria": "Asia",
    "Jordan": "Asia",
    "Israel": "Asia",
    "Lebanon": "Asia",
    "United Arab Emirates": "Asia",
    "Qatar": "Asia",
    "Kuwait": "Asia",
    "Bahrain": "Asia",
    "Oman": "Asia",
    "Yemen": "Asia",
    "Palestine": "Asia",
    "Afghanistan": "Asia",
    
    // # Central Asia
    "Kazakhstan": "Asia",
    "Uzbekistan": "Asia",
    "Turkmenistan": "Asia",
    "Kyrgyzstan": "Asia",
    "Tajikistan": "Asia",
    
    // # Africa
    "Egypt": "Africa",
    "Algeria": "Africa",
    "Morocco": "Africa",
    "Tunisia": "Africa",
    "Libya": "Africa",
    "Sudan": "Africa",
    "South Sudan": "Africa",
    "Ethiopia": "Africa",
    "Somalia": "Africa",
    "Kenya": "Africa",
    "Tanzania": "Africa",
    "Uganda": "Africa",
    "Rwanda": "Africa",
    "Burundi": "Africa",
    "Nigeria": "Africa",
    "Ghana": "Africa",
    "Ivory Coast": "Africa",
    "Senegal": "Africa",
    "Mali": "Africa",
    "Burkina Faso": "Africa",
    "Niger": "Africa",
    "Chad": "Africa",
    "Cameroon": "Africa",
    "Central African Republic": "Africa",
    "Democratic Republic of the Congo": "Africa",
    "Republic of the Congo": "Africa",
    "Gabon": "Africa",
    "Equatorial Guinea": "Africa",
    "South Africa": "Africa",
    "Namibia": "Africa",
    "Botswana": "Africa",
    "Zimbabwe": "Africa",
    "Zambia": "Africa",
    "Malawi": "Africa",
    "Mozambique": "Africa",
    "Angola": "Africa",
    "Madagascar": "Africa",
    "Mauritius": "Africa",
    "Comoros": "Africa",
    "Seychelles": "Africa",
    "Mauritania": "Africa",
    "Guinea": "Africa",
    "Guinea-Bissau": "Africa",
    "Sierra Leone": "Africa",
    "Liberia": "Africa",
    "Togo": "Africa",
    "Benin": "Africa",
    "Eritrea": "Africa",
    "Djibouti": "Africa",
    "Lesotho": "Africa",
    "Eswatini": "Africa",
    
    // # Oceania
    "Australia": "Oceania",
    "New Zealand": "Oceania",
    "Papua New Guinea": "Oceania",
    "Fiji": "Oceania",
    "Solomon Islands": "Oceania",
    "Vanuatu": "Oceania",
    "Samoa": "Oceania",
    "Kiribati": "Oceania",
    "Tonga": "Oceania",
    "Micronesia": "Oceania",
    "Marshall Islands": "Oceania",
    "Palau": "Oceania",
    "Tuvalu": "Oceania",
    "Nauru": "Oceania"
  };
  
  // # Try direct lookup
  if (continentMap[normalizedName]) {
    return continentMap[normalizedName];
  }
  
  // # Try case-insensitive lookup
  const lowerCaseName = normalizedName.toLowerCase();
  const matchingKey = Object.keys(continentMap).find(key => 
    key.toLowerCase() === lowerCaseName
  );
  
  if (matchingKey) {
    return continentMap[matchingKey];
  }
  
  // # Try with underscores replaced by spaces
  if (normalizedName.includes('_')) {
    const nameWithSpaces = normalizedName.replace(/_/g, ' ');
    if (continentMap[nameWithSpaces]) {
      return continentMap[nameWithSpaces];
    }
    
    // # Try case-insensitive with spaces
    const matchingSpaceKey = Object.keys(continentMap).find(key => 
      key.toLowerCase() === nameWithSpaces.toLowerCase()
    );
    
    if (matchingSpaceKey) {
      return continentMap[matchingSpaceKey];
    }
  }
  
  // # Try with spaces replaced by underscores
  if (normalizedName.includes(' ')) {
    const nameWithUnderscores = normalizedName.replace(/ /g, '_');
    if (continentMap[nameWithUnderscores]) {
      return continentMap[nameWithUnderscores];
    }
    
    // # Try case-insensitive with underscores
    const matchingUnderscoreKey = Object.keys(continentMap).find(key => 
      key.toLowerCase() === nameWithUnderscores.toLowerCase()
    );
    
    if (matchingUnderscoreKey) {
      return continentMap[matchingUnderscoreKey];
    }
  }
  
  return "Unknown";
};

/**
 * # Group countries by continent
 * @returns {Object} Object with continents as keys and arrays of country names as values
 */
export const getCountriesByContinent = () => {
  const continents = {
    "North America": [],
    "South America": [],
    "Europe": [],
    "Asia": [],
    "Africa": [],
    "Oceania": [],
    "Unknown": []
  };
  
  getAllCountryNames().forEach(country => {
    const continent = getCountryContinent(country);
    if (continents[continent]) {
      continents[continent].push(country);
    } else {
      continents.Unknown.push(country);
    }
  });
  
  return continents;
};

/**
 * # Find country by partial name
 * @param {string} partialName - Partial name to search for
 * @returns {Array} Array of matching country names
 */
export const findCountryByPartialName = (partialName) => {
  if (!partialName || typeof partialName !== 'string') return [];
  
  const searchTerm = partialName.toLowerCase().trim();
  if (!searchTerm) return [];
  
  return getAllCountryNames().filter(country => 
    country.toLowerCase().includes(searchTerm)
  );
};

/**
 * # Get ISO code from various formats
 * Tries to find an ISO code from different input formats (name, code, etc.)
 * @param {string} input - The input to convert to ISO code
 * @returns {string} The ISO code or "Unknown" if not found
 */
export const getISOFromAnyFormat = (input) => {
  if (!input) return "Unknown";
  
  const trimmed = input.trim();
  
  // # Check if it's already a valid ISO code
  if (isValidISO(trimmed)) {
    return trimmed.toUpperCase();
  }
  
  // # Special case handling for problematic countries
  const specialCases = {
    'TURKMENISTAN': 'TKM',
    'GERMANY': 'DEU',
    'PAPUA_NEW_GUINEA': 'PNG',
    'CZECH_REPUBLIC': 'CZE',
    'TIMOR_LESTE': 'TLS',
    'IVORY_COAST': 'CIV',
    'SOUTH_KOREA': 'KOR',
    'HONG_KONG': 'HKG',
    'ALGERIA': 'DZA',
    'UK': 'GBR',
    'UNITED_KINGDOM': 'GBR',
    'UNITED KINGDOM': 'GBR',
    'BAHRAIN': 'BHR',
    'KUWAIT': 'KWT',
    'SWEDEN': 'SWE',
    'COLOMBIA': 'COL',
    'JAPAN': 'JPN',
    'NETHERLANDS': 'NLD',
    'TANZANIA': 'TZA',
    'ARGENTINA': 'ARG',
    'DENMARK': 'DNK',
    'EGYPT': 'EGY',
    'SENEGAL': 'SEN',
    'CAMEROON': 'CMR',
    'FIJI': 'FJI',
    'ROMANIA': 'ROU',
    'IRELAND': 'IRL',
    'PERU': 'PER',
    'COSTA_RICA': 'CRI',
    'GREECE': 'GRC',
    'NEPAL': 'NPL',
    'PHILIPPINES': 'PHL',
    'BOLIVIA': 'BOL',
    'TUNISIA': 'TUN',
    'UGANDA': 'UGA',
    'BRUNEI': 'BRN',
    'INDONESIA': 'IDN',
    'BELGIUM': 'BEL',
    'USA': 'USA',
    'COMOROS': 'COM',
    'THAILAND': 'THA',
    'POLAND': 'POL',
    'SUDAN': 'SDN',
    'SAUDI_ARABIA': 'SAU',
    'SYRIA': 'SYR',
    'UKRAINE': 'UKR',
    'SOMALIA': 'SOM',
    'GHANA': 'GHA',
    'AFGHANISTAN': 'AFG',
    'KAZAKHSTAN': 'KAZ',
    'ECUADOR': 'ECU',
    'AUSTRIA': 'AUT',
    'MONGOLIA': 'MNG',
    'YEMEN': 'YEM',
    'FINLAND': 'FIN',
    'VIETNAM': 'VNM',
    'PANAMA': 'PAN',
    'OMAN': 'OMN',
    'LAOS': 'LAO',
    'MALDIVES': 'MDV',
    'INDIA': 'IND',
    'UZBEKISTAN': 'UZB',
    'SLOVAKIA': 'SVK',
    'UAE': 'ARE',
    'UNITED_ARAB_EMIRATES': 'ARE',
    'UNITED ARAB EMIRATES': 'ARE'
  };
  
  if (specialCases[trimmed]) {
    return specialCases[trimmed];
  }
  
  // # Try to get ISO from country name
  const isoFromName = getCountryISO(trimmed);
  if (isoFromName !== "Unknown") {
    return isoFromName;
  }
  
  // # Try with underscores replaced by spaces
  if (trimmed.includes('_')) {
    const nameWithSpaces = trimmed.replace(/_/g, ' ');
    const isoFromSpaces = getCountryISO(nameWithSpaces);
    if (isoFromSpaces !== "Unknown") {
      return isoFromSpaces;
    }
  }
  
  // # Try with spaces replaced by underscores
  if (trimmed.includes(' ')) {
    const nameWithUnderscores = trimmed.replace(/ /g, '_');
    const isoFromUnderscores = getCountryISO(nameWithUnderscores);
    if (isoFromUnderscores !== "Unknown") {
      return isoFromUnderscores;
    }
  }
  
  // # Try with proper capitalization (first letter uppercase, rest lowercase)
  // # This helps with all-uppercase country names like "TURKMENISTAN"
  if (trimmed === trimmed.toUpperCase()) {
    const properCase = trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
    const isoFromProperCase = getCountryISO(properCase);
    if (isoFromProperCase !== "Unknown") {
      return isoFromProperCase;
    }
  }
  
  // # Try to match with partial name
  const possibleMatches = findCountryByPartialName(trimmed);
  if (possibleMatches.length === 1) {
    return getCountryISO(possibleMatches[0]);
  }
  
  return "Unknown";
};

/**
 * # Get neighboring countries
 * @param {string} countryName - The name of the country
 * @returns {Array} Array of neighboring country names
 * Note: This is a simplified version with limited data
 */
export const getNeighboringCountries = (countryName) => {
  // # Simplified map of some country borders
  const bordersMap = {
    "United States": ["Canada", "Mexico"],
    "Canada": ["United States"],
    "Mexico": ["United States", "Guatemala", "Belize"],
    "Germany": ["France", "Netherlands", "Belgium", "Luxembourg", "Switzerland", "Austria", "Czech Republic", "Poland", "Denmark"],
    "France": ["Spain", "Andorra", "Monaco", "Italy", "Switzerland", "Germany", "Luxembourg", "Belgium"],
    "United Kingdom": ["Ireland"],
    "China": ["Russia", "Mongolia", "North Korea", "Vietnam", "Laos", "Myanmar", "India", "Bhutan", "Nepal", "Pakistan", "Afghanistan", "Tajikistan", "Kyrgyzstan", "Kazakhstan"],
    "Brazil": ["Uruguay", "Argentina", "Paraguay", "Bolivia", "Peru", "Colombia", "Venezuela", "Guyana", "Suriname", "French Guiana"],
    // # Add more as needed
  };
  
  return bordersMap[countryName] || [];
};

/**
 * # Get region for a country
 * More specific than continent
 * @param {string} countryName - The name of the country
 * @returns {string} The region name
 */
export const getCountryRegion = (countryName) => {
  // # Normalize country name for lookup
  const normalizedName = countryName?.trim();
  if (!normalizedName) return "Unknown";
  
  // # Simplified region mapping
  const regionMap = {
    // # Arab Countries / Middle East & North Africa (MENA)
    "Egypt": "North Africa",
    "Algeria": "North Africa",
    "Libya": "North Africa",
    "Tunisia": "North Africa",
    "Morocco": "North Africa",
    "Mauritania": "North Africa",
    "Sudan": "North Africa",
    "Saudi Arabia": "Middle East",
    "United Arab Emirates": "Middle East",
    "Qatar": "Middle East",
    "Kuwait": "Middle East",
    "Bahrain": "Middle East",
    "Oman": "Middle East",
    "Yemen": "Middle East",
    "Iraq": "Middle East",
    "Syria": "Middle East",
    "Lebanon": "Middle East",
    "Jordan": "Middle East",
    "Palestine": "Middle East",
    "Somalia": "East Africa",
    "Djibouti": "East Africa",
    "Comoros": "East Africa",
    
    // # North America
    "United States": "North America",
    "Canada": "North America",
    "Mexico": "Central America",
    "Guatemala": "Central America",
    "Honduras": "Central America",
    "El Salvador": "Central America",
    "Nicaragua": "Central America",
    "Costa Rica": "Central America",
    "Panama": "Central America",
    "Cuba": "Caribbean",
    "Jamaica": "Caribbean",
    "Haiti": "Caribbean",
    "Dominican Republic": "Caribbean",
    
    // # Europe
    "United Kingdom": "Western Europe",
    "Ireland": "Western Europe",
    "France": "Western Europe",
    "Germany": "Western Europe",
    "Netherlands": "Western Europe",
    "Belgium": "Western Europe",
    "Luxembourg": "Western Europe",
    "Switzerland": "Western Europe",
    "Austria": "Western Europe",
    "Italy": "Southern Europe",
    "Spain": "Southern Europe",
    "Portugal": "Southern Europe",
    "Greece": "Southern Europe",
    "Poland": "Eastern Europe",
    "Czech Republic": "Eastern Europe",
    "Slovakia": "Eastern Europe",
    "Hungary": "Eastern Europe",
    "Romania": "Eastern Europe",
    "Bulgaria": "Eastern Europe",
    "Ukraine": "Eastern Europe",
    "Russia": "Eastern Europe",
    "Sweden": "Northern Europe",
    "Norway": "Northern Europe",
    "Finland": "Northern Europe",
    "Denmark": "Northern Europe",
    
    // # Asia
    "China": "East Asia",
    "Japan": "East Asia",
    "South Korea": "East Asia",
    "North Korea": "East Asia",
    "Taiwan": "East Asia",
    "India": "South Asia",
    "Pakistan": "South Asia",
    "Bangladesh": "South Asia",
    "Sri Lanka": "South Asia",
    "Nepal": "South Asia",
    "Thailand": "Southeast Asia",
    "Vietnam": "Southeast Asia",
    "Indonesia": "Southeast Asia",
    "Malaysia": "Southeast Asia",
    "Philippines": "Southeast Asia",
    "Singapore": "Southeast Asia",
    
    // # Add more as needed
  };
  
  // # Try direct lookup
  if (regionMap[normalizedName]) {
    return regionMap[normalizedName];
  }
  
  // # Try case-insensitive lookup
  const lowerCaseName = normalizedName.toLowerCase();
  const matchingKey = Object.keys(regionMap).find(key => 
    key.toLowerCase() === lowerCaseName
  );
  
  if (matchingKey) {
    return regionMap[matchingKey];
  }
  
  // # Try with underscores replaced by spaces
  if (normalizedName.includes('_')) {
    const nameWithSpaces = normalizedName.replace(/_/g, ' ');
    if (regionMap[nameWithSpaces]) {
      return regionMap[nameWithSpaces];
    }
    
    // # Try case-insensitive with spaces
    const matchingSpaceKey = Object.keys(regionMap).find(key => 
      key.toLowerCase() === nameWithSpaces.toLowerCase()
    );
    
    if (matchingSpaceKey) {
      return regionMap[matchingSpaceKey];
    }
  }
  
  // # Try with spaces replaced by underscores
  if (normalizedName.includes(' ')) {
    const nameWithUnderscores = normalizedName.replace(/ /g, '_');
    if (regionMap[nameWithUnderscores]) {
      return regionMap[nameWithUnderscores];
    }
    
    // # Try case-insensitive with underscores
    const matchingUnderscoreKey = Object.keys(regionMap).find(key => 
      key.toLowerCase() === nameWithUnderscores.toLowerCase()
    );
    
    if (matchingUnderscoreKey) {
      return regionMap[matchingUnderscoreKey];
    }
  }
  
  // # Fallback to continent if region not found
  return getCountryContinent(normalizedName);
};

/**
 * # Get common alternative names for a country
 * @param {string} countryName - The name of the country
 * @returns {Array} Array of alternative names
 */
export const getCountryAlternativeNames = (countryName) => {
  const alternativeNamesMap = {
    "United States": ["USA", "US", "America", "United States of America"],
    "United Kingdom": ["UK", "Britain", "Great Britain", "England"],
    "Russia": ["Russian Federation"],
    "China": ["People's Republic of China", "PRC"],
    "South Korea": ["Korea, Republic of", "Republic of Korea"],
    "North Korea": ["Democratic People's Republic of Korea", "DPRK"],
    // # Add more as needed
  };
  
  return alternativeNamesMap[countryName] || [];
};

/**
 * # Get country data for visualization
 * @param {string} countryNameOrISO - Country name or ISO code
 * @returns {Object} Country data object with various properties
 */
export const getCountryData = (countryNameOrISO) => {
  // # Try to get ISO code first
  const isoCode = getISOFromAnyFormat(countryNameOrISO);
  if (isoCode === "Unknown") return null;
  
  // # Get country name
  const countryName = getCountryNameFromISO(isoCode);
  
  // # Return comprehensive country data
  return {
    name: countryName,
    isoCode: isoCode,
    continent: getCountryContinent(countryName),
    region: getCountryRegion(countryName),
    neighbors: getNeighboringCountries(countryName),
    alternativeNames: getCountryAlternativeNames(countryName)
  };
};

/**
 * # Format country data for heat map
 * @param {Object} data - Raw data object with country names or ISO codes as keys
 * @param {Object} options - Options for formatting
 * @returns {Object} Formatted data for heat map visualization
 */
export const formatCountryDataForHeatMap = (data, options = {}) => {
  const {
    useISO = true,
    defaultValue = 0,
    includeEmptyCountries = false,
    normalizeValues = false,
    preserveUnmappedCountries = true
  } = options;
  
  // # Validate input
  if (!data || typeof data !== 'object') return {};
  
  // # Transform data to consistent format
  let transformedData = {};
  
  // # Process each entry in the data
  Object.entries(data).forEach(([key, value]) => {
    // # Get ISO code from key (which could be country name or ISO)
    const isoCode = getISOFromAnyFormat(key);
    
    // # Skip unknown countries if not using original keys as fallback
    if (isoCode === "Unknown") {
      // # If we couldn't map to an ISO code, keep the original key for display
      if (!useISO || preserveUnmappedCountries) {
        transformedData[key] = typeof value === 'number' ? value : defaultValue;
      }
      console.warn(`⚠️ Unmapped country in formatCountryDataForHeatMap: ${key}`);
      return;
    }
    
    // # Use the appropriate key format based on options
    const outputKey = useISO ? isoCode : getCountryNameFromISO(isoCode);
    
    // # Store the value
    transformedData[outputKey] = (transformedData[outputKey] || 0) + 
                               (typeof value === 'number' ? value : defaultValue);
  });
  
  // # Include all countries if requested
  if (includeEmptyCountries) {
    const allKeys = useISO ? getAllISOCodes() : getAllCountryNames();
    allKeys.forEach(key => {
      if (!transformedData[key]) {
        transformedData[key] = defaultValue;
      }
    });
  }
  
  // # Normalize values if requested (0-1 scale)
  if (normalizeValues) {
    const values = Object.values(transformedData);
    const maxValue = Math.max(...values, 1); // Avoid division by zero
    
    Object.keys(transformedData).forEach(key => {
      transformedData[key] = transformedData[key] / maxValue;
    });
  }
  
  return transformedData;
};

/**
 * # Group country data by region
 * @param {Object} data - Data object with country names or ISO codes as keys
 * @returns {Object} Data grouped by region
 */
export const groupCountryDataByRegion = (data) => {
  if (!data || typeof data !== 'object') return {};
  
  const groupedData = {};
  
  Object.entries(data).forEach(([key, value]) => {
    // # Get country name (whether key is ISO or name)
    let countryName = key;
    if (isValidISO(key)) {
      countryName = getCountryNameFromISO(key);
    }
    
    // # Get region
    const region = getCountryRegion(countryName);
    
    // # Initialize region if needed
    if (!groupedData[region]) {
      groupedData[region] = {};
    }
    
    // # Add data to region
    groupedData[region][countryName] = value;
  });
  
  return groupedData;
};

/**
 * # Get ISO to country name mapping
 * @returns {Object} Object with ISO codes as keys and country names as values
 */
export const getISOToCountryMap = () => {
  const map = {};
  Object.entries(countryISOMap).forEach(([name, iso]) => {
    map[iso] = name;
  });
  return map;
};

/**
 * # Get original country name from ISO code
 * This function returns the original country name format from our data
 * @param {string} isoCode - The ISO code to look up
 * @param {string} preferredFormat - The preferred format (e.g., 'UPPERCASE', 'Title_Case', 'Title Case')
 * @returns {string} The country name in the original format or "Unknown" if not found
 */
export const getOriginalCountryNameFromISO = (isoCode, preferredFormat = 'UPPERCASE') => {
  // # Handle case sensitivity and trimming
  const normalizedCode = isoCode?.trim()?.toUpperCase();
  
  if (!normalizedCode) return "Unknown";
  
  // # Find all country names that map to this ISO code
  const matchingEntries = Object.entries(countryISOMap).filter(([_, code]) => code === normalizedCode);
  
  if (matchingEntries.length === 0) return "Unknown";
  
  // # Based on preferred format, return the appropriate name
  if (preferredFormat === 'UPPERCASE') {
    // # Prefer all uppercase names (like "ALGERIA")
    const uppercaseName = matchingEntries.find(([name, _]) => name === name.toUpperCase());
    if (uppercaseName) return uppercaseName[0];
  } else if (preferredFormat === 'Title_Case') {
    // # Prefer title case with underscores (like "Papua_New_Guinea")
    const titleCaseWithUnderscores = matchingEntries.find(([name, _]) => {
      return name.includes('_') && 
             name.split('_').every(word => word.charAt(0) === word.charAt(0).toUpperCase() && 
                                         word.slice(1) === word.slice(1).toLowerCase());
    });
    if (titleCaseWithUnderscores) return titleCaseWithUnderscores[0];
  } else if (preferredFormat === 'Title Case') {
    // # Prefer title case without underscores (like "Papua New Guinea")
    const titleCaseWithoutUnderscores = matchingEntries.find(([name, _]) => {
      return !name.includes('_') && 
             name.split(' ').every(word => word.charAt(0) === word.charAt(0).toUpperCase() && 
                                          word.slice(1) === word.slice(1).toLowerCase());
    });
    if (titleCaseWithoutUnderscores) return titleCaseWithoutUnderscores[0];
  }
  
  // # If no match for preferred format, try to find the best match
  // # First preference: all uppercase (like in the table)
  const uppercaseName = matchingEntries.find(([name, _]) => name === name.toUpperCase());
  if (uppercaseName) return uppercaseName[0];
  
  // # Second preference: names with underscores (like in the table)
  const nameWithUnderscores = matchingEntries.find(([name, _]) => name.includes('_'));
  if (nameWithUnderscores) return nameWithUnderscores[0];
  
  // # Return the first match if no better match found
  return matchingEntries[0][0];
};

// # Export default for convenience
export default {
  countryISOMap,
  getCountryISO,
  getCountryNameFromISO,
  isValidISO,
  getAllISOCodes,
  getAllCountryNames,
  transformDataToISO,
  transformDataFromISO,
  getCountryContinent,
  getCountriesByContinent,
  findCountryByPartialName,
  getISOFromAnyFormat,
  getNeighboringCountries,
  getCountryRegion,
  getCountryAlternativeNames,
  getCountryData,
  formatCountryDataForHeatMap,
  groupCountryDataByRegion,
  getISOToCountryMap,
  getOriginalCountryNameFromISO
};
